export const availTers = [
  'ad',
  'ae',
  'af',
  'ag',
  'ai',
  'al',
  'am',
  'ao',
  'aq',
  'ar',
  'as',
  'at',
  'au',
  'aw',
  'ax',
  'az',
  'bb',
  'be',
  'bf',
  'bg',
  'bh',
  'bi',
  'bj',
  'bl',
  'bm',
  'bn',
  'bo',
  'bq',
  'br',
  'bs',
  'bt',
  'bv',
  'bw',
  'bz',
  'ca',
  'cc',
  'cd',
  'cf',
  'cg',
  'ch',
  'ci',
  'ck',
  'cl',
  'cm',
  'co',
  'cr',
  'cv',
  'cw',
  'cx',
  'cy',
  'cz',
  'de',
  'dj',
  'dk',
  'dm',
  'do',
  'dz',
  'ec',
  'ee',
  'eg',
  'eh',
  'er',
  'es',
  'et',
  'fi',
  'fj',
  'fk',
  'fo',
  'fr',
  'ga',
  'gb',
  'gd',
  'ge',
  'gf',
  'gg',
  'gh',
  'gi',
  'gl',
  'gm',
  'gn',
  'gp',
  'gq',
  'gr',
  'gs',
  'gt',
  'gu',
  'gw',
  'gy',
  'hm',
  'hn',
  'hr',
  'ht',
  'hu',
  'id',
  'ie',
  'il',
  'im',
  'in',
  'io',
  'iq',
  'is',
  'it',
  'je',
  'jm',
  'jo',
  'jp',
  'ke',
  'ki',
  'km',
  'kn',
  'kw',
  'ky',
  'kz',
  'lb',
  'lc',
  'li',
  'lk',
  'lr',
  'ls',
  'lt',
  'lu',
  'lv',
  'ly',
  'ma',
  'mc',
  'me',
  'mf',
  'mg',
  'ml',
  'mn',
  'mp',
  'mq',
  'mr',
  'ms',
  'mt',
  'mu',
  'mv',
  'mw',
  'mx',
  'mz',
  'na',
  'nc',
  'ne',
  'nf',
  'ng',
  'ni',
  'nl',
  'no',
  'np',
  'nr',
  'nu',
  'nz',
  'om',
  'pa',
  'pe',
  'pf',
  'pg',
  'pk',
  'pl',
  'pm',
  'pn',
  'pr',
  'ps',
  'pt',
  'pw',
  'py',
  'qa',
  're',
  'ro',
  'rs',
  'rw',
  'sa',
  'sb',
  'sc',
  'se',
  'sh',
  'si',
  'sj',
  'sk',
  'sl',
  'sm',
  'sn',
  'so',
  'sr',
  'st',
  'sv',
  'sx',
  'sz',
  'tc',
  'td',
  'tf',
  'tg',
  'tj',
  'tk',
  'tm',
  'tn',
  'to',
  'tr',
  'tt',
  'tv',
  'tz',
  'ua',
  'ug',
  'um',
  'us',
  'uy',
  'uz',
  'va',
  'vc',
  've',
  'vg',
  'vi',
  'wf',
  'ws',
  'yt',
  'za',
  'zm',
  'zw'
];
const regionNamesInEnglish = new Intl.DisplayNames(['en'], { type: 'region' });
export const regionFilterValues = [...availTers.map((ter) => [ter, regionNamesInEnglish.of(ter.toUpperCase()) + ` [${ter.toLocaleUpperCase()}]`])];

export const availLicenses = [
  ['avod', 'AVOD'],
  ['svod', 'SVOD'],
  ['est', 'EST'],
  ['tvod', 'TVOD']
];

export const subRights = [
  'ar-sa',
  'de-de',
  'en-us',
  'es-la',
  'es-es',
  'fr-fr',
  'id-id',
  'it-it',
  'ms-my',
  'pt-br',
  'pt-pt',
  'ru-ru',
  'th-th',
  'vi-vn'
].sort((a, b) => a.localeCompare(b));

export const dubRights = ['de-de', 'en-us', 'es-la', 'fr-fr', 'ja-jp', 'pt-br'].sort((a, b) => a.localeCompare(b));

export const regionRights = [
  'AE',
  'AR',
  'AS',
  'AU',
  'BR',
  'CA',
  'CH',
  'CO',
  'DE',
  'DK',
  'ES',
  'FI',
  'FR',
  'GB',
  'GU',
  'IN',
  'IT',
  'MP',
  'MX',
  'NL',
  'NO',
  'NZ',
  'PR',
  'PT',
  'SA',
  'SE',
  'TH',
  'UM',
  'US',
  'VI',
  'RU'
].sort((a, b) => a.localeCompare(b));

export const territoryGrouping = {
  Africa: [
    { code: 'AO', label: 'Angola' },
    { code: 'BF', label: 'Burkina Faso' },
    { code: 'BI', label: 'Burundi' },
    { code: 'BJ', label: 'Benin' },
    { code: 'BW', label: 'Botswana' },
    { code: 'CD', label: 'Congo, The Democratic Republic of the' },
    { code: 'CF', label: 'Central African Republic' },
    { code: 'CG', label: 'Congo' },
    { code: 'CI', label: "Côte d'Ivoire" },
    { code: 'CM', label: 'Cameroon' },
    { code: 'CV', label: 'Cabo Verde' },
    { code: 'DJ', label: 'Djibouti' },
    { code: 'DZ', label: 'Algeria' },
    { code: 'EG', label: 'Egypt' },
    { code: 'EH', label: 'Western Sahara' },
    { code: 'ER', label: 'Eritrea' },
    { code: 'ET', label: 'Ethiopia' },
    { code: 'GA', label: 'Gabon' },
    { code: 'GH', label: 'Ghana' },
    { code: 'GM', label: 'Gambia' },
    { code: 'GN', label: 'Guinea' },
    { code: 'GQ', label: 'Equatorial Guinea' },
    { code: 'GW', label: 'Guinea-Bissau' },
    { code: 'KE', label: 'Kenya' },
    { code: 'KM', label: 'Comoros' },
    { code: 'LR', label: 'Liberia' },
    { code: 'LS', label: 'Lesotho' },
    { code: 'LY', label: 'Libya' },
    { code: 'MA', label: 'Morocco' },
    { code: 'MG', label: 'Madagascar' },
    { code: 'ML', label: 'Mali' },
    { code: 'MR', label: 'Mauritania' },
    { code: 'MU', label: 'Mauritius' },
    { code: 'MW', label: 'Malawi' },
    { code: 'MZ', label: 'Mozambique' },
    { code: 'NA', label: 'Namibia' },
    { code: 'NE', label: 'Niger' },
    { code: 'NG', label: 'Nigeria' },
    { code: 'RW', label: 'Rwanda' },
    { code: 'SC', label: 'Seychelles' },
    { code: 'SD', label: 'Sudan' },
    { code: 'SL', label: 'Sierra Leone' },
    { code: 'SN', label: 'Senegal' },
    { code: 'SO', label: 'Somalia' },
    { code: 'SS', label: 'South Sudan' },
    { code: 'ST', label: 'Sao Tome and Principe' },
    { code: 'SZ', label: 'Eswatini' },
    { code: 'TD', label: 'Chad' },
    { code: 'TG', label: 'Togo' },
    { code: 'TN', label: 'Tunisia' },
    { code: 'TZ', label: 'Tanzania, United Republic of' },
    { code: 'UG', label: 'Uganda' },
    { code: 'YT', label: 'Mayotte' },
    { code: 'ZA', label: 'South Africa' },
    { code: 'ZM', label: 'Zambia' },
    { code: 'ZW', label: 'Zimbabwe' }
  ],
  Asia: [
    { code: 'AF', label: 'Afghanistan' },
    { code: 'AM', label: 'Armenia' },
    { code: 'AZ', label: 'Azerbaijan' },
    { code: 'BD', label: 'Bangladesh' },
    { code: 'BT', label: 'Bhutan' },
    { code: 'GE', label: 'Georgia' },
    { code: 'ID', label: 'Indonesia' },
    { code: 'IN', label: 'India' },
    { code: 'IR', label: 'Iran' },
    { code: 'KG', label: 'Kyrgyzstan' },
    { code: 'KH', label: 'Cambodia' },
    { code: 'KZ', label: 'Kazakhstan' },
    { code: 'LA', label: 'Lao' },
    { code: 'LK', label: 'Sri Lanka' },
    { code: 'MM', label: 'Myanmar' },
    { code: 'MN', label: 'Mongolia' },
    { code: 'MV', label: 'Maldives' },
    { code: 'MY', label: 'Malaysia' },
    { code: 'NP', label: 'Nepal' },
    { code: 'PH', label: 'Philippines' },
    { code: 'PK', label: 'Pakistan' },
    { code: 'SG', label: 'Singapore' },
    { code: 'TH', label: 'Thailand' },
    { code: 'TJ', label: 'Tajikistan' },
    { code: 'TL', label: 'Timor-Leste' },
    { code: 'TM', label: 'Turkmenistan' },
    { code: 'VN', label: 'Vietnam' },
    { code: 'UZ', label: 'Uzbekistan' }
  ],
  'East & Southeast Asia (Territories)': [
    { code: 'BN', label: 'Brunei Darussalam' },
    { code: 'CC', label: 'Cocos (Keeling) Islands' },
    { code: 'CN', label: 'China' },
    { code: 'CX', label: 'Christmas Island' },
    { code: 'HK', label: 'Hong Kong' },
    { code: 'IO', label: 'British Indian Ocean Territory' },
    { code: 'JP', label: 'Japan' },
    { code: 'KP', label: "Korea, Democratic People's Republic of" },
    { code: 'KR', label: 'Korea, Republic of' },
    { code: 'MO', label: 'Macao' },
    { code: 'TW', label: 'Taiwan, Province of China' }
  ],
  Europe: [
    { code: 'AD', label: 'Andorra' },
    { code: 'AL', label: 'Albania' },
    { code: 'AT', label: 'Austria' },
    { code: 'AX', label: 'Åland Islands' },
    { code: 'BA', label: 'Bosnia and Herzegovina' },
    { code: 'BE', label: 'Belgium' },
    { code: 'BG', label: 'Bulgaria' },
    { code: 'BY', label: 'Belarus' },
    { code: 'CH', label: 'Switzerland' },
    { code: 'CY', label: 'Cyprus' },
    { code: 'CZ', label: 'Czechia' },
    { code: 'DE', label: 'Germany' },
    { code: 'DK', label: 'Denmark' },
    { code: 'EE', label: 'Estonia' },
    { code: 'ES', label: 'Spain' },
    { code: 'GL', label: 'Greenland' },
    { code: 'FI', label: 'Finland' },
    { code: 'FO', label: 'Faroe Islands' },
    { code: 'FR', label: 'France' },
    { code: 'GB', label: 'United Kingdom' },
    { code: 'GG', label: 'Guernsey' },
    { code: 'GI', label: 'Gibraltar' },
    { code: 'GR', label: 'Greece' },
    { code: 'HR', label: 'Croatia' },
    { code: 'HU', label: 'Hungary' },
    { code: 'IE', label: 'Ireland' },
    { code: 'IM', label: 'Isle of Man' },
    { code: 'IS', label: 'Iceland' },
    { code: 'IT', label: 'Italy' },
    { code: 'JE', label: 'Jersey' },
    { code: 'LI', label: 'Liechtenstein' },
    { code: 'LT', label: 'Lithuania' },
    { code: 'LU', label: 'Luxembourg' },
    { code: 'LV', label: 'Latvia' },
    { code: 'MC', label: 'Monaco' },
    { code: 'MD', label: 'Moldova, Republic of' },
    { code: 'ME', label: 'Montenegro' },
    { code: 'MK', label: 'North Macedonia' },
    { code: 'MT', label: 'Malta' },
    { code: 'NL', label: 'Netherlands' },
    { code: 'NO', label: 'Norway' },
    { code: 'PL', label: 'Poland' },
    { code: 'PT', label: 'Portugal' },
    { code: 'RU', label: 'Russia' },
    { code: 'RO', label: 'Romania' },
    { code: 'RS', label: 'Serbia' },
    { code: 'SE', label: 'Sweden' },
    { code: 'SI', label: 'Slovenia' },
    { code: 'SJ', label: 'Svalbard and Jan Mayen' },
    { code: 'SK', label: 'Slovakia' },
    { code: 'SM', label: 'San Marino' },
    { code: 'UA', label: 'Ukraine' },
    { code: 'VA', label: 'Holy See (Vatican City State)' }
  ],
  'Latin America & Caribbean': [
    { code: 'AG', label: 'Antigua and Barbuda' },
    { code: 'AI', label: 'Anguilla' },
    { code: 'AR', label: 'Argentina' },
    { code: 'AW', label: 'Aruba' },
    { code: 'BB', label: 'Barbados' },
    { code: 'BL', label: 'Saint Barthélemy' },
    { code: 'BM', label: 'Bermuda' },
    { code: 'BO', label: 'Bolivia, Plurinational State of' },
    { code: 'BQ', label: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BR', label: 'Brazil' },
    { code: 'BS', label: 'Bahamas' },
    { code: 'BZ', label: 'Belize' },
    { code: 'CL', label: 'Chile' },
    { code: 'CO', label: 'Colombia' },
    { code: 'CR', label: 'Costa Rica' },
    { code: 'CU', label: 'Cuba' },
    { code: 'CW', label: 'Curaçao' },
    { code: 'DM', label: 'Dominica' },
    { code: 'DO', label: 'Dominican Republic' },
    { code: 'EC', label: 'Ecuador' },
    { code: 'GD', label: 'Grenada' },
    { code: 'GF', label: 'French Guiana' },
    { code: 'GP', label: 'Guadeloupe' },
    { code: 'GT', label: 'Guatemala' },
    { code: 'GY', label: 'Guyana' },
    { code: 'HN', label: 'Honduras' },
    { code: 'HT', label: 'Haiti' },
    { code: 'JM', label: 'Jamaica' },
    { code: 'KN', label: 'Saint Kitts and Nevis' },
    { code: 'KY', label: 'Cayman Islands' },
    { code: 'LC', label: 'Saint Lucia' },
    { code: 'MF', label: 'Saint Martin (French part)' },
    { code: 'MQ', label: 'Martinique' },
    { code: 'MS', label: 'Montserrat' },
    { code: 'NI', label: 'Nicaragua' },
    { code: 'PA', label: 'Panama' },
    { code: 'PE', label: 'Peru' },
    { code: 'PR', label: 'Puerto Rico' },
    { code: 'PY', label: 'Paraguay' },
    { code: 'SR', label: 'Suriname' },
    { code: 'SV', label: 'El Salvador' },
    { code: 'SX', label: 'Sint Maarten (Dutch part)' },
    { code: 'TC', label: 'Turks and Caicos Islands' },
    { code: 'TT', label: 'Trinidad and Tobago' },
    { code: 'UY', label: 'Uruguay' },
    { code: 'VC', label: 'Saint Vincent and the Grenadines' },
    { code: 'VE', label: 'Venezuela, Bolivarian Republic of' },
    { code: 'VG', label: 'Virgin Islands, British' },
    { code: 'VI', label: 'Virgin Islands, U.S.' }
  ],
  'Middle East': [
    { code: 'AE', label: 'United Arab Emirates' },
    { code: 'BH', label: 'Bahrain' },
    { code: 'IL', label: 'Israel' },
    { code: 'IQ', label: 'Iraq' },
    { code: 'JO', label: 'Jordan' },
    { code: 'KW', label: 'Kuwait' },
    { code: 'LB', label: 'Lebanon' },
    { code: 'OM', label: 'Oman' },
    { code: 'PS', label: 'Palestine, State of' },
    { code: 'QA', label: 'Qatar' },
    { code: 'SA', label: 'Saudi Arabia' },
    { code: 'SY', label: 'Syria' },
    { code: 'TR', label: 'Turkey' },
    { code: 'YE', label: 'Yemen' }
  ],
  'North America': [
    { code: 'CA', label: 'Canada' },
    { code: 'MX', label: 'Mexico' },
    { code: 'PM', label: 'Saint Pierre and Miquelon' },
    { code: 'US', label: 'United States' }
  ],
  Oceania: [
    { code: 'AS', label: 'American Samoa' },
    { code: 'AU', label: 'Australia' },
    { code: 'CK', label: 'Cook Islands' },
    { code: 'FJ', label: 'Fiji' },
    { code: 'FM', label: 'Micronesia, Federated States of' },
    { code: 'GU', label: 'Guam' },
    { code: 'HM', label: 'Heard Island and McDonald Islands' },
    { code: 'KI', label: 'Kiribati' },
    { code: 'MP', label: 'Northern Mariana Islands' },
    { code: 'NC', label: 'New Caledonia' },
    { code: 'NF', label: 'Norfolk Island' },
    { code: 'NR', label: 'Nauru' },
    { code: 'NU', label: 'Niue' },
    { code: 'NZ', label: 'New Zealand' },
    { code: 'PF', label: 'French Polynesia' },
    { code: 'PG', label: 'Papua New Guinea' },
    { code: 'PN', label: 'Pitcairn' },
    { code: 'PW', label: 'Palau' },
    { code: 'SB', label: 'Solomon Islands' },
    { code: 'TK', label: 'Tokelau' },
    { code: 'TO', label: 'Tonga' },
    { code: 'TV', label: 'Tuvalu' },
    { code: 'UM', label: 'United States Minor Outlying Islands' },
    { code: 'WF', label: 'Wallis and Futuna' },
    { code: 'WS', label: 'Samoa' },
    { code: 'VU', label: 'Vanuatu' }
  ],
  'Polar / Uninhabited': [
    { code: 'AQ', label: 'Antarctica' },
    { code: 'BV', label: 'Bouvet Island' },
    { code: 'FK', label: 'Falkland Islands' },
    { code: 'GS', label: 'South Georgia and the South Sandwich Islands' },
    { code: 'RE', label: 'Réunion' },
    { code: 'SH', label: 'Saint Helena, Ascension and Tristan da Cunha' },
    { code: 'TF', label: 'French Southern Territories' }
  ]
} as const;

export type TerritoryGrouping = typeof territoryGrouping;
export type Region = keyof TerritoryGrouping;
export type Territory = TerritoryGrouping[Region][number];

export const formatUTC = (dateInt: Date | string, addOffset = false) => {
  const offsetDate = dateInt instanceof Date ? dateInt : new Date(dateInt);
  const offset = addOffset ? offsetDate.getTimezoneOffset() : -offsetDate.getTimezoneOffset();
  offsetDate.setTime(offsetDate.getTime() + offset * 60000);
  return offsetDate;
};

export const defaultAvailEndDate = formatUTC(new Date('9998-11-30T07:59:00')).toISOString();
